import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { MailAccount } from "../../comunications/_types/mail-account";
import { CaseLogType } from "../../cases/_types/case-log-type";

export class ContractCaseLogType extends Resource {
    public override type = 'contractCaseLogTypes';

    @prop()
    @required()
    public contractId!: string;

    @prop()
    @required()
    public caseLogTypeId!: string;

    @prop()
    public caseLogType!: CaseLogType;

    /** JSON { fields: [...] } propio del contrato; con contenido sustituye al del tipo */
    @prop()
    public fieldsConfiguration?: string;

}